module.exports = __webpack_public_path__ + "static/img/sing.df3d138a.webp";